// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__ApANH","Main_content":"Main_Main_content__sh1u-","Main_content_content":"Main_Main_content_content__-PHqr","Main_content_img":"Main_Main_content_img__NWrjC"};